import TefConfigurationGridCard from "./components/TefConfigurationGridCard";
import { tefProviders } from "@/features/establishments/constants/tefModels.constant";

const TefConfigurationList = () => {
  return (
    <div className="grid grid-cols-2 gap-6 max-h-[calc(100vh-200px)] overflow-auto">
      {Object.entries(tefProviders).map(([provider, { Icon, label }]) => (
        <TefConfigurationGridCard
          key={provider}
          Icon={Icon}
          label={`Tabela de códigos ${label}`}
          provider={provider}
        />
      ))}
    </div>
  );
}

export default TefConfigurationList;
